<template>
  <div class="container">
    <div class="head" style="background-color: #f33737;text-align: center;color: #ffffff;line-height: 45px;">
      <img class="back" src="https://zhulong-lib.oss-cn-beijing.aliyuncs.com/img/eval/images/back.png" alt="" @click="back">
      <span style="font-size: 16px;">霍兰德职业兴趣测试</span>
    </div>
    <div class="main">
      <div class="progress">
        <div class="text">进度（{{testIndex+1}}/{{list.length}}）</div>
        <van-progress color="#ee0a24" stroke-width="10" pivot-text="" :percentage="(testIndex+1) * 100 / list.length" />
      </div>
      <!-- 可以滑动 -->
      <!-- <slider v-if="list.length" ref="mySwiper" :options="swiperOption" @slide="slide">
        <slideritem v-for="(item,key) in list" :key="key">
          <div class="shiti_box">
            <p class="shiti">
              <span class="quesNo">{{key+1}}.</span>
              <span class="quesTitle">{{item.ques_title}}</span>
            </p>
            <p class="like" @click="nextItem(1)">
              <img class="choice" src="http://eva.zhulong.com/static/images/select.png" alt="">
              喜欢
            </p>
            <p class="no_like" @click="nextItem(2)">
              <img class="choice" src="http://eva.zhulong.com/static/images/select.png" alt="">
              不喜欢
            </p>
          </div>
        </slideritem>
      </slider> -->
      <!-- 不能滑动 -->
      <div v-for="(item,key) in list" :key="key">
        <div class="shiti_box" v-if="testIndex+1 == key+1">
            <p class="shiti">
              <span class="quesNo">{{testIndex+1}}.</span>
              <span class="quesTitle">{{item.ques_title}}</span>
            </p>
            <p class="like" @click="nextItem(1,item)">
              <img v-if="show==1" class="choice" src="https://newoss.zhulong.com/forum/202301/03/19/1672746483515766.png" alt="">
              喜欢
            </p>
            <p class="no_like" @click="nextItem(2,item)">
              <img v-if="show==2" class="choice" src="https://newoss.zhulong.com/forum/202301/03/19/1672746483515766.png" alt="">
              不喜欢
            </p>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { slider, slideritem } from 'vue-concise-slider'// import slider components
import { start, submitAnswer } from "@/api/interview";
export default {
  components: {
    slider,
    slideritem,
  },
  data(){
    const that = this
    return {
      list: [],
      user_paper_id: this.$route.query.user_paper_id,
      resume_id: this.$route.query.resume_id,
      testIndex: 0,
      show: 0,
      swiperOption: {
        freeze: false,
        currentPage: 0, // 当前页码
        timingFunction: 'ease',
        thresholdDistance: 500, // 滑动判定距离
        // thresholdTime: 100, // 滑动判定时间
        loop: false, // 循环滚动
        direction: 'horizontal', // 方向设置，垂直滚动
        pagination: false, // 底部小圆点是否隐藏
        // infinite: 1, // 无限滚动前后遍历数
        // slidesToScroll: 1, // 每次滑动项数
      }
    }
  },
  created(){
    this.start()
  },
  mounted(){
    
  },
  methods:{
    // 获取试题
    start(){
      const info = {
        resume_id: this.resume_id,
        user_paper_id: this.user_paper_id
      }
      start(info).then(res=>{
        console.log(res,'res')
        // this.content = res.result
        this.list = res.result
        // this.list.forEach(res=>{
        //   res.selected = false
        //   if(res.)
        // })
        for(let i in this.list){
          this.list[i].selected = false
          if(this.list[i].answer == ''){
            this.testIndex = Number(i)
            break
          }
        }
        console.log(this.testIndex,'this.testIndex')
      })
    },
    slide(data) {
      console.log(data)
      this.testIndex = data.currentPage
      // this.scrollToTop(data.currentPage)
    },
    // nextItem(type){
    //   var like = document.getElementsByClassName('like')
    //   var no_like = document.getElementsByClassName('no_like')
    //   if(type==1){
    //     like[this.testIndex].style = 'background: #d0d7d9'
    //   }else{
    //     no_like[this.testIndex].style = 'background: #d0d7d9'
    //   }
    //   // this.$refs.mySwiper.$emit('slideNext')
    // },
    nextItem(type,item){
      var like = document.getElementsByClassName('like')
      var no_like = document.getElementsByClassName('no_like')
      if(!item.selected){
        if(type==1){
          like[0].style = 'background: #d0d7d9'
          item.selected = true
          this.show = 1
        }else{
          no_like[0].style = 'background: #d0d7d9'
          item.selected = true
          this.show = 2
        }
        setTimeout(() => {
          console.log('zhixingle')
          this.submitAnswer(type,item)
        }, 200);
      }else{
        this.$toast('已经选择，不可更改')
      }
    },
    // 提交结果
    submitAnswer(type,item){
      const info = {
        resume_id: this.resume_id,
        // resume_id:127315,
        id: item.ques_result_id,
        answer: type == 1 ? 'A' : 'B',
        user_paper_id: item.user_paper_id
      }
      submitAnswer(info).then(res=>{
        console.log(res,'res')
        this.show = 0
        if(res.errNo === 0 ){
          if(this.testIndex < this.list.length - 1){
            this.testIndex += 1
          }else{
            this.$router.push({
              path: 'report',
              query:{
                resume_id: this.resume_id
              }
            })
          }
        }else{
          this.$toast(msg)
        }
      })
    },
    back(){
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
  overflow: hidden;
}
.head{
  height: 88px;
  width: 100%;
  position: relative;
  .topimg{
    width: 100%;
    height: 100px;
  }
  .back{
    width: 22px;
    height: 36px;
    position: absolute;
    top: 24px;
    left: 5%;
  }
}
.main{
  margin: 40px 4% 40px;
  .progress{
    .text{
      font-size: 26px;
      margin-bottom: 10px;
    }
  }
  .shiti_box{
    width: 100%;
    height: calc(100vh - 248px);
    text-align: left;
    .shiti{
      font-size: 32px;
      font-weight: bolder;
      line-height: 180px;
    }
    .like,.no_like{
      height: 98px;
      line-height: 98px;
      text-indent: 60px;
      background: #eff2f3;
      border-radius: 50px;
      position: relative;
      font-size: 32px;
      .choice {
        position: absolute;
        top: 42px;
        right: 5%;
        width: 40px;
        height: 18px;
      }
    }
    .no_like {
      margin-top: 60px;
    }
  }
}
.slider-item{
  color: #333;
  justify-content: flex-start;
}
</style>